import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Accordion from '../accordion';
import { Body } from '../typography';

import TheryButton from './theory-button-mobile';
import { getDeviceType } from '../../lib/utils';

const TitlesContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const AccordionTheory = ({ theme, microTheme, children, showTheoriesModal }) => {
    const openModal = () => {
        showTheoriesModal();
    };

    if (getDeviceType() === 'MOBILE') {
        return (
            <TheryButton onClick={openModal}>
                <TitlesContainer>
                    <Body lv={5}>{theme}</Body>
                    <Body level={2} fontWeight="semi-bold">
                        {microTheme}
                    </Body>
                </TitlesContainer>
            </TheryButton>
        );
    }

    return (
        <Accordion>
            <TitlesContainer>
                <Body lv={5}>{theme}</Body>
                <Body level={2} fontWeight="semi-bold">
                    {microTheme}
                </Body>
            </TitlesContainer>
            {children}
        </Accordion>
    );
};

AccordionTheory.propTypes = {
    theme: PropTypes.string,
    microTheme: PropTypes.string,
    children: PropTypes.node,
    showTheoriesModal: PropTypes.func,
};

export default AccordionTheory;
